import { render } from "./ChartsDataNew.vue?vue&type=template&id=27c603f2"
import script from "./ChartsDataNew.vue?vue&type=script&lang=js"
export * from "./ChartsDataNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__